import { NarrativeHeader } from '../../PublicNarrativeHeader';
import { NarrativeSidebar } from '../../NarrativeSidebar';
import { PublicNarrativeRichTextEditor } from '../../PublicNarrativeEditor';
import type { Props } from '../types';

export const MobileLayout = ({
  errors,
  values,
  onChange,
  onSetFairValue,
  isLoading,
  onSubmit,
  submitLabel,
  owner,
  initialContentHtml,
  company,
  onReset,
  pastAnnualRevenueEarnings,
  calculationBreakDownOutput,
  narrativeId,
  onContentChange,
  onHeaderChange,
}: Props) => {
  return (
    <>
      <div className="grid grid-rows-[min-content_min-content_auto] content-start gap-x2">
        <NarrativeHeader
          errors={errors}
          values={values}
          onChange={onHeaderChange}
          isLoading={isLoading}
          onSubmit={onSubmit}
          submitLabel={submitLabel}
          owner={owner}
          company={company}
        />

        <NarrativeSidebar
          company={company}
          onChange={onChange}
          onSetFairValue={onSetFairValue}
          values={values}
          onReset={onReset}
          readOnly={false}
          owner={{
            displayName: owner?.displayName || '',
            publicId: owner?.publicId || '',
          }}
          narrativeType={'USER'}
          pastAnnualRevenueEarnings={pastAnnualRevenueEarnings}
          narrativeId={narrativeId}
          calculationBreakDownOutput={calculationBreakDownOutput}
        />
      </div>
      <PublicNarrativeRichTextEditor
        onUpdate={onContentChange}
        defaultContent={initialContentHtml}
      />
    </>
  );
};
